import { useMemo } from 'react'

interface FeeCalculatorResult {
  amountIn: string
  amountOut: string
  fee: string
  feePercentage: number
}

export function useFeeCalculator(
  amount: string,
  feePercentage: number = 1.0
): FeeCalculatorResult {
  return useMemo(() => {
    if (!amount || isNaN(parseFloat(amount)) || parseFloat(amount) <= 0) {
      return {
        amountIn: '0',
        amountOut: '0',
        fee: '0',
        feePercentage,
      }
    }

    const amountInFloat = parseFloat(amount)
    const feeAmount = amountInFloat * (feePercentage / 100)
    const amountOutFloat = amountInFloat - feeAmount

    return {
      amountIn: amount,
      amountOut: amountOutFloat.toFixed(6),
      fee: feeAmount.toFixed(6),
      feePercentage,
    }
  }, [amount, feePercentage])
}
